module.exports = __webpack_public_path__ + "static/img/tab-banner1.e2df249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/tab-banner1.png
// module id = wxmT
// module chunks = 1